/**
 * Created by hyt on 2016/9/23.
 */
/*require('./../../style/session-item.less');*/
import Vm from '../sw-component/utils/Vm'; 
var vm_template = require('./../sw-component/sw/session-item1.sw');
var $ = require('jQuery'),
  template = require('../../template/session-item1.html'),
  //Component = require('./../Component'),
  dispatcher = require('./../../global/dispatcher'),
  ActionType = require('./../../constant/ActionType'),
  ContactStatus = require('./../../constant/ContactStatus'),
  config = require('./../../global/config'),
  isEmpty = require('./../../global/utils').isEmpty,
  html2Text = require('./../../utils/html2Text'),
  XssFilter = require('../../../lib/XssFilter'),
  timeFormatter = require('../../utils/timeFormatter');
var RichTextFormat = require('../../../lib/RichTextFormat');
var gdic = require('./../../global/globalDic');
var falseNewsDic = require('./../../global/falseNewsDic');
var utils = require('./../../global/utils');
var DefaultLastMsgs = require('./../../constant/DefaultLastMsgs');
// var groupCore = require('../../../sdk/core/group/index');
var isGroupUser = utils.isGroupUser;
var jsonHandler = utils.jsonHandler;
var IEVersion = utils.IEVersion();
var isEmpty = utils.isEmpty;
var strToNumCompare = utils.strToNumCompare;
var isAnonymousSession = utils.isAnonymousSession;
var is_remind_helper = utils.is_remind_helper;
var isShopModeUserSource = utils.isShopModeUserSource

var replaceUrlSrc = function (txt) {
  var content = txt.replace(/&nbsp;/g, " ").replace(/<br>/g, " ").replace(/\s/g, " ");
  var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/ig;
  return content.replace(reg, function (item) {
    return "[链接]";
  });
};

var formatcontent = function (msg, session) {
  var content = msg.content;
  if (!content) {
    return '';
  }
  var type = msg.show_type ? msg.show_type : content.type ? content.type : null;
  var status = msg.status;
  var lastMsg = "",
    sendingIcon = '<i class="im-last-msg-sending"></i>',
    failIcon = '<i class="im-last-msg-failed"></i>';
  switch (status) {
    case "UPLOADING":
    case "SENDING":
      lastMsg += sendingIcon;
      break;
    case "UPLOAD_FAIL":
    case "FAIL":
      lastMsg += failIcon;
      break;
    case "SUCCESS":
      break;
    default:
      break;
  }
  // 非标准模式的最后一条信息语义恢复
  var convert = config["session-msg-converter"](msg);
  if (convert) {
    lastMsg += replaceUrlSrc(convert);
    return lastMsg;
  }
  var person;
  var contact = session.contact || session.group;
  var me = gdic.get('meInfo');
  var meKey = me.user_id + '@' + me.user_source;
  // var meKey = session.contact && session.contact.group_info && session.contact.group_info.self_info && session.contact.group_info.self_info.user_id ? session.contact.group_info.self_info.user_id + '@' + session.contact.group_info.self_info.user_source : '';
  if (!isEmpty(msg.sender_info) && isGroupUser({ user_source: contact.user_source })) {
    var sendInfo = msg.sender_info;
    var userKey = sendInfo.user_id + '@' + sendInfo.user_source;
    if (!isEmpty(contact) && !isEmpty(contact.remark_user_obj) && contact.remark_user_obj[userKey]) {
      sendInfo.remark = contact.remark_user_obj[userKey];
    }
    person = (!isEmpty(sendInfo.remark) && !isEmpty(sendInfo.remark.remark_name)) ? sendInfo.remark.remark_name : !isEmpty(sendInfo.nick_name) ? sendInfo.nick_name : sendInfo.user_name ? sendInfo.user_name : '未知';
  }
  if (!isEmpty(person) && ['modify_msg', 'tip', 'operation_tip', 'auth_tip'].indexOf(content.type) === -1) {
    if (sendInfo.user_id + '@' + sendInfo.user_source != meKey) lastMsg = person + ': ' + lastMsg;// likd-a mark here
  }
  // if (!isEmpty(session.contact) && !isEmpty(session.contact.remark) && !isEmpty(session.contact.remark.remark_name)) {
  //   if (!isEmpty(msg.content._operator) && !isEmpty(msg.content._replaceMsg) && !isEmpty(msg.content._operator)) {
  //     msg.content.text = msg.content._replaceMsg.substring(0, msg.content._operator.pos_start) + session.contact.remark.remark_name + msg.content._replaceMsg.substring(msg.content._operator.pos_end);
  //   }
  // }
  // @逻辑
  var isAtMe;
  var in_group = session.contact && session.contact.in_group === 1;
  var content_at_msg = '';
  if (!isEmpty(msg.at_info)) {
    var atInfo = msg.at_info;
    if (typeof (msg.at_info) === 'string') {
      atInfo = jsonHandler.parse(msg.at_info);
    }
    var targetsArr = atInfo.targets;
    if (!isEmpty(targetsArr) && targetsArr.length > 0) {
      $.each(targetsArr, function (key, item) {
        var atKey = item.id + '@' + item.source;
        var isGroupAt = isGroupUser({ user_source: item.source });
        if (isGroupAt || atKey == meKey) {
          isAtMe = true;
          session.groupAt_index = msg.at_index;
        }
        if (!in_group && isAtMe && content.msg) {
          var originalLen = content.msg.length;
          var me = config['me']();
          if (!msg.extendAt && !isNaN(item.pos_start) && me.userInfo && me.userInfo.user_name && me.userInfo.user_name && item.pos_end > item.pos_start) {
            content_at_msg = content.msg.substring(0, item.pos_start) + '@' + me.userInfo.user_name + content.msg.substring(item.pos_end, originalLen);
          }
        }
      });
    }
    var amount = Number(msg.showed_count) - Number(msg.at_index);
    if (isAtMe && amount < 0) {
      if (!!session.unread && parseInt(session.unread) > 0) {
        lastMsg = '<span style="color:red;">[有人@我]</span>' + lastMsg;
      }
    }
  }
  var extra = content.extra ? jsonHandler.parse(content.extra) : {};
  if (!isEmpty(extra) && !isEmpty(extra.better_msg)) {
    if (extra.better_msg.type == 'shop_common_card') {
      var elements = extra.better_msg.element || [];
      elements.forEach(function (element) {
        if (element.type == "text" && !isEmpty(element.text) && isEmpty(content.msg)) {
          content.msg = element.text;
        }
      });
    }
  }
  // 免打扰逻辑
  if (session && session.unread && session.unread > 0 && contact && contact.group_info && contact.msg_set && contact.msg_set.silent == 1) {
    lastMsg = '[' + session.unread + '条]' + lastMsg;
  }
  let contactName = contact && contact.remark && contact.remark.remark_name ? contact.remark.remark_name : (contact ? contact.user_name : '');
  if (isEmpty(contactName) && isAnonymousSession(contact)) {
    contactName = '游客' + contact.user_id;
  }
  if (!config['is_support_provide_contactinfo'] && ['provide_contactinfo_card', 'default_contactinfo_card'].indexOf(type) >= 0) {
    type = null;
  }
  if (['msg_batch_forward_card'].indexOf(type) >= 0) {
    if (!config['is_support_forward']) {
      type = null;
    } else if (!isEmpty(content) && content.forward_one_by_one) {
      type = msg.forward_msg_show_type;
      content = msg.forward_msg_content;
    }
  }
  if (['wechat_notice_card'].indexOf(type) >= 0) {
    if (content.msgs_preview && content.msgs_preview[0]) {
      content = content.msgs_preview[0].content || '{}';
      try {
        content = JSON.parse(content);
      } catch (e) {
        content = {};
      }
      type = content.type;
    } else {
      type = null;
    }
  }
  switch (type) {
    case "text":
      //链接
      if (!in_group && isAtMe && content_at_msg) {
        lastMsg += replaceUrlSrc(html2Text(content_at_msg));
      } else {
        lastMsg += replaceUrlSrc(html2Text(content.msg));
      }
      break;
    case 'modify_msg':
    case 'tip':
      var text = content.origl_text ? content.origl_text : content.msg ? content.msg : content.text;
      if (!text) {
        text = RichTextFormat.richTextFormat(msg).content.origl_text;
      }
      lastMsg += text;
      break;
    case 'operation_tip':
    case 'auth_tip':
      lastMsg += content.default_text;
      break;
    case 'image':
      lastMsg += '[图片]';
      break;
    case 'file':
      lastMsg += '[文件]';
      break;
    case 'video':
      lastMsg += '[视频]';
      break;
    case 'audio':
      lastMsg += '[语音]';
      break;
    case 'call_audio':
      lastMsg += '[语音聊天]';
      break;
    case 'call_video':
      lastMsg += '[视频聊天]';
      break;
    case 'standard_evaluate_card1':
    case 'standard_evaluate_card2':
      lastMsg += '[评价邀请]';
      break;
    case 'universal_card1':
    case 'universal_card2':
    case 'universal_card3':
    case 'universal_card4':
    case 'universal_card5':
    case 'universal_card6':
    case 'private_card_ganji':
      var contact = contact;
      var contactkey = contact.user_id + '@' + contact.user_source;
      if (content.card_content && gdic.get('sysUser') && gdic.get('sysUser').indexOf(contactkey) !== -1) {
        lastMsg += content.card_content;
      } else {
        lastMsg += type === 'private_card_ganji' ? '[卡片]' : '[链接]';
        if (type !== 'private_card_ganji' && !isEmpty(content.card_title) && content.card_title.length) {
          lastMsg += content.card_title;
        }
      }
      break;
    case 'shop_common_card':
      if (isEmpty(content.msg)) {
        if (!isEmpty(content.element) && content.element.length) {
          for (var index = 0; index < content.element.length; index++) {
            if (!isEmpty(content.element[index]) && content.element[index].type == 'text' && !isEmpty(content.element[index].text)) {
              lastMsg += content.element[index].text;
              break;
            }
          }
        } else {
          lastMsg += "[卡片]";
        }
      } else {
        lastMsg += content.msg;
      }
      break;
    case 'provide_contactinfo_card':
      lastMsg += '[名片]' + contactName + '邀请您提供联系方式';
      break;
    case 'default_contactinfo_card':
      lastMsg += '[名片]' + (contactName ? (contactName + '的') : '') + '联系方式';
      break;
    case 'msg_batch_forward_card':
      lastMsg += '[聊天记录]';
      break;
    case 'wechat_notice_card':
      lastMsg += '[提醒]';
      break;
    default:
      // 不支持消息体的默认展示文案
      if (msg && msg.content && msg.content.common_default_text) {
        msg.show_type = 'tip';
        msg.content = {
          type: 'tip',
          text: msg.content.common_default_text,
          extra: msg.content.common_default_text
        }
        lastMsg += msg.content.text;
      } else if (!isEmpty(DefaultLastMsgs) && !isEmpty(DefaultLastMsgs[msg.show_type])) {
        lastMsg += '您收到了一条消息';
      } else {
        lastMsg += '消息格式暂不支持，请在客户端查看';
      }
      break;
    /*case 'card':
     case 'minicard':
     lastMsg += '[帖子]';
     break;*/
  }
  // 对于已经删除的消息，最后一条消息显示为空
  if (msg.msg_status + '' === '2') {
    lastMsg = '';
  }
  return lastMsg;
};

class ContactSessionItem extends Vm {
  constructor (options) {
    var defaults = {
      template: template
    };
    $.extend(defaults, options);
    super(defaults);
    (function (self) {
      self._element.click(function () {
        dispatcher.dispatch({
          type: ActionType.SESSION_CLICK,
          data: self._data.session
        });
      });
    })(this);
  }

  vm_template () {
    return vm_template();
  } 

  vm_methods() {
    return {
      handleImgFailLoad: function(e) {
        var current_src = $(e.target).attr('src');
        if (current_src !== config['default-avatar']) {
          $(e.target).attr('src', config['default-avatar']);
        }
      }
    }
  }

  vm_data() {
    return {
      name: '',
      content: '',
      time: '',
      show_time: true,
      avatar: '',
      checked: false,
      count: '',
      im_hide: true,
      rash: false,
      not_answered: false,
      need_space: false,
      is_shop_business: false,
      im_session_no_online_status: false,
      im_session_blacked:  true,
      im_session_ics: false,
      im_session_offline: false,
      im_session_group: false,
      shop_icon_text: '',
      im_session_shop: false,
      im_session_silent: false,
      im_session_ses_top: false,
      im_session_ics: false,
      unread_show_type: ''
    }
  }

  mutation(data) {
      let new_data = {};
      let session = data.session;
      let contact = session.contact || session.group,
      name = '';
      is_online = !isEmpty(data.is_online) ? data.is_online : session ? session.is_online : (session.is_top_group || contact.in_group) ? 1 : 0;

      if (contact.remark) {
        name = contact.remark.remark_name || contact.user_name || contact.name || '未知';
      } else {
        name = contact.user_name || contact.name || '未知';
      }
    
      if (isAnonymousSession(contact) && name == '未知') {
        name = '游客' + contact.user_id;
      }

      if (utils.isEmojiCharacter(name)) {
        new_data.need_space = true;
      }
      //判断是否为IE
      if (IEVersion !== -1) {
        //$element.find(".im-msg-time").css('margin-top', '-14px')
      }

      var avatar = (contact && contact.avatar) ? contact.avatar : isAnonymousSession(contact) ? config['default-anonymous-avatar'] : config['default-avatar'];


      if (is_remind_helper(contact.user_id, contact.user_source, contact.shop_id, contact.shop_source)) {
        name = '提醒服务';
        if (config['message_reminder']) {
          avatar = config['message_reminder'].avatar;
        }
        new_data.im_session_no_online_status = true;
      }

      new_data.avatar = avatar;

      new_data.name = name;

      if (!this._data.session)
        return;

      if (!!session.unread && parseInt(session.unread) > 0) {
        var txt = session.unread > 99 ? '99+' : session.unread;
        new_data.count = txt;
        new_data.im_hide = false;
        if (!!session.unread_show_type && session.unread_show_type !== '') {
          new_data.count = '';
          new_data.unread_show_type = session.unread_show_type
        } else {
          //$element.find('.im-session-msg-count').removeClass('rash');
          new_data.rash = false;
          new_data.unread_show_type = '';
        }
      } else {
        new_data.im_hide = true;
      }
    
      if (isGroupUser({ user_source: contact.user_source }) || session.is_top_group || contact.is_anonymous_group) {
        new_data.im_session_group = true;
      } else {
        if (is_online == ContactStatus.ONLINE) {
          new_data.im_session_offline = false;
        } else if (is_online == ContactStatus.OFFLINE) {
          new_data.im_session_offline = true;
        }
      }

      // 置顶会话
      if (contact && contact.msg_set && contact.msg_set.ses_top == 1 && !contact.shop_id) {
        new_data.im_session_ses_top = true;
      } else {
        new_data.im_session_ses_top = false;
      }
      // 免打扰会话
      if (contact && contact.msg_set && contact.msg_set.silent == 1) {
        new_data.im_session_silent = true;
      } else {
        new_data.im_session_silent = false;
      }
    
      // 是否是帮帮智能客服
      if (contact && contact.is_ics_user) {
        new_data.im_session_ics = true;
      }
    
      // 拉黑会话
      if (contact && contact.is_blacked == 1) {
        new_data.im_session_blacked = true
      } else {
        new_data.im_session_blacked = false;
      }
    
      // 店铺会话
      new_data.shop_icon_text = '';
      if (contact && contact.shop_id && contact.shop_source) {
        new_data.im_session_shop = true
        var txt = gdic.get('position') && gdic.get('position') == 'RIGHT_BOTTOM' ? '商' : null;
        if (txt) {
          new_data.shop_icon_text = txt;
        }
      } else {
        new_data.im_session_shop = false;
      }

      if (!new_data.im_session_shop && contact && isShopModeUserSource(contact.user_source)) {
        new_data.is_shop_business = true;
      }
    
      // 加载失败之后，恢复默认图像
      // $element.find(".im-session-img").error(function () {
      //   var current_src = $(this).attr('src');
      //   if (current_src !== config['default-avatar']) {
      //     $(this).attr('src', config['default-avatar']);
      //   }
      // });

      var time, content;
      if (this._data.session.msg) {
        var msg = this._data.session.msg;
        time = timeFormatter(msg.send_time);
        content = formatcontent.call(this, msg, this._data.session);
      } else {
        time = "";
        content = "";
      }

      new_data.checked = !!session.checked;

      new_data.not_answered = false;
      // 音视频假消息替换
      if (contact && contact.user_id && contact.user_source) {
        var contactkey = contact.user_id + '@' + contact.user_source + ((contact.shop_id && contact.shop_source) ? ('@@' + contact.shop_id + '@' + contact.shop_source) : '');
        var tmpMsg = (!isEmpty(this._data.session.falseMsg) && this._data.session.falseMsg.msg_id) ? this._data.session.falseMsg : gdic.get('tmpMsg-session-' + contactkey);
        if (!isEmpty(tmpMsg) && this._data.session.msg && this._data.session.msg.msg_id && falseNewsDic.getExistFalseMsg(contactkey, this._data.session.msg.msg_id)) {
          if (!isEmpty(this._data.session.msg)) {
            if (strToNumCompare(tmpMsg.msg_id, this._data.session.msg.msg_id) > 0) {
              if (tmpMsg.call_type === 'audio') {
                content = '[语音通话]';
                if (tmpMsg.not_answered) {
                  new_data.not_answered = true;
                }
              } else if (tmpMsg.call_type === 'video') {
                content = '[视频通话]';
                if (tmpMsg.not_answered) {
                  new_data.not_answered = true;
                }
              } else {
                content = tmpMsg.content ? (tmpMsg.content.msg || '') : '';
              }
              time = timeFormatter(tmpMsg.send_time);
            } else {
              gdic.set('tmpMsg-session-' + contactkey, null);
            }
          }
        }
      }

      if (this._data.session.is_top_group) {
        new_data.show_time = false;
        //this._element.find(".im-session-username").css('padding-right', '57px');
      } else {
        new_data.show_time = true;
        new_data.time = time;
      }
      // xssFilter,将'<'替换成’&lt;将'>'替换成&gt;
      content = XssFilter.doFilter(content);
      new_data.content = content;

      return new_data
  }

  setSession(session) {
    this.setData({
      session: session
    });
  }

  render() {
    var $element = this.getElement(),
    data = this._data,
    session = data.session,
    contact = session.contact || session.group,
    name = '',
    is_online = !isEmpty(data.is_online) ? data.is_online : session ? session.is_online : (session.is_top_group || contact.in_group) ? 1 : 0;

  if (!!session.unread && parseInt(session.unread) > 0) {
    var txt = session.unread > 99 ? '99+' : session.unread;
    $element.find('.im-session-msg-count').text(txt).removeClass('im-hide');
    if (!!session.unread_show_type && session.unread_show_type !== '') {
      $element.find('.im-session-msg-count').text('').addClass(session.unread_show_type);
    } else {
      $element.find('.im-session-msg-count').removeClass('rash');
    }
  } else {
    $element.find('.im-session-msg-count').addClass('im-hide');
  }

  if (isGroupUser({ user_source: contact.user_source }) || session.is_top_group || contact.is_anonymous_group) {
    $element.find(".im-session-online-status").addClass('im-session-group');
  } else {
    if (is_online == ContactStatus.ONLINE) {
      $element.find(".im-session-online-status").removeClass('im-session-offline');
    } else if (is_online == ContactStatus.OFFLINE) {
      $element.find(".im-session-online-status").addClass('im-session-offline');
    }
  }

  if (contact.remark) {
    name = contact.remark.remark_name || contact.user_name || contact.name || '未知';
  } else {
    name = contact.user_name || contact.name || '未知';
  }

  if (isAnonymousSession(contact) && name == '未知') {
    name = '游客' + contact.user_id;
  }

  var avatar = (contact && contact.avatar) ? contact.avatar : isAnonymousSession(contact) ? config['default-anonymous-avatar'] : config['default-avatar'];
  if (is_remind_helper(contact.user_id, contact.user_source, contact.shop_id, contact.shop_source)) {
    name = '提醒服务';
    if (config['message_reminder']) {
      avatar = config['message_reminder'].avatar;
    }
    $element.find('.im-session-online-status').addClass('im-session-no-online-status');
  }
  $element.find(".im-session-img").attr('src', avatar);
  if (utils.isEmojiCharacter(name)) {
    $element.find('.im-session-username').addClass('need-space')
  }
  $element.find(".im-session-username").text(name);
  //判断是否为IE
  if (IEVersion !== -1) {
    $element.find(".im-msg-time").css('margin-top', '-14px')
  }

  // 置顶会话
  if (contact && contact.msg_set && contact.msg_set.ses_top == 1 && !contact.shop_id) {
    this._element.addClass('im-session-ses-top');
  } else {
    this._element.removeClass('im-session-ses-top');
  }
  // 免打扰会话
  if (contact && contact.msg_set && contact.msg_set.silent == 1) {
    this._element.addClass('im-session-silent');
  } else {
    this._element.removeClass('im-session-silent');
  }

  // 是否是帮帮智能客服
  if (contact && contact.is_ics_user) {
    this._element.addClass('im-session-ics');
  }

  // 拉黑会话
  if (contact && contact.is_blacked == 1) {
    this._element.addClass('im-session-blacked');
  } else {
    this._element.removeClass('im-session-blacked');
  }

  // 店铺会话
  if (contact && contact.shop_id && contact.shop_source) {
    this._element.addClass('im-session-shop');
    var txt = gdic.get('position') && gdic.get('position') == 'RIGHT_BOTTOM' ? '商' : null;
    if (txt) {
      this._element.find('.im-shop-icon').text(txt);
    }
  } else {
    this._element.removeClass('im-session-shop');
  }

  // 加载失败之后，恢复默认图像
  $element.find(".im-session-img").error(function () {
    var current_src = $(this).attr('src');
    if (current_src !== config['default-avatar']) {
      $(this).attr('src', config['default-avatar']);
    }
  });

  if (session.checked) {
    this._element.addClass('im-session-active');
  }
  else {
    this._element.removeClass('im-session-active');
  }

  if (!this._data.session)
    return;
  var time, content;
  if (this._data.session.msg) {
    var msg = this._data.session.msg;
    time = timeFormatter(msg.send_time);

    // var _session = this._data.session;
    // // 撤回、更改群名、邀请、踢出群
    // if (_session.contact.is_group && (_session.msg.show_type == 'operation_tip' || _session.msg.show_type == 'modify_msg')) {
    //   // debugger;
    //   config['getUserinfo']([{
    //     user_id: _session.msg.content.operator.id ? _session.msg.content.operator.id : _session.msg.sender_id,
    //     user_source: _session.msg.content.operator.source ? _session.msg.content.operator.source : _session.msg.sender_source
    //   }], function (user) {
    //     var me_key = _session.contact.group_info.creator.user_id + '@' + _session.contact.group_info.creator.user_source;
    //     // var groupKey = _session.contact.user_id + '@' + _session.contact.user_source;
    //     var userKey = _session.msg.content.operator.id ? (_session.msg.content.operator.id + '@' + _session.msg.content.operator.source) : (_session.msg.sender_id + '@' + _session.msg.sender_source); 
    //     var _info = user[userKey];
    //     var re_index = _session.msg.content.operator.id ? (_session.msg.content.default_text.indexOf("更改群名称为") !== -1 ? _session.msg.content.default_text.indexOf("更改群名称为") : _session.msg.content.default_text.indexOf("邀请")) : _session.msg.content.text.indexOf("撤回一条消息");
    //     // var member_Info = groupCore.getGroupMemberUserInfoFromLocal(groupKey, userKey);
    //     if (re_index !== -1 && _session.msg.content.default_text) {
    //       _session.msg.content.default_text = (userKey == me_key ? '你' : ((!isEmpty(_info) && !isEmpty(_info.remark) && !isEmpty(_info.remark.remark_name)) ? _info.remark.remark_name : (!isEmpty(_info) && !isEmpty(_info.remark.nick_name)) ? _info.remark.nick_name : _info.user_name)) + _session.msg.content.default_text.substring(re_index);
    //     }
    //     if (re_index !== -1 && _session.msg.content.text) {
    //       _session.msg.content.text = (userKey == me_key ? '你' : ((!isEmpty(_info) && !isEmpty(_info.remark) && !isEmpty(_info.remark.remark_name)) ? _info.remark.remark_name : (!isEmpty(_info) && !isEmpty(_info.remark) && !isEmpty(_info.remark.nick_name)) ? _info.remark.nick_name : _info.user_name)) + _session.msg.content.text.substring(re_index);
    //       _session.msg.replace.content.text = (userKey == me_key ? '你' : ((!isEmpty(_info) && !isEmpty(_info.remark) && !isEmpty(_info.remark.remark_name)) ? _info.remark.remark_name : (!isEmpty(_info) && !isEmpty(_info.remark) && !isEmpty(_info.remark.nick_name)) ? _info.remark.nick_name : _info.user_name)) + _session.msg.content.text.substring(re_index);
    //     }
    //   });
    // }
    content = formatcontent.call(this, msg, this._data.session);
  } else {
    time = "";
    content = "";
  }

  this._element.find(".im-last-msg").removeClass('im-false-not-answered');
  // 音视频假消息替换
  if (contact && contact.user_id && contact.user_source) {
    var contactkey = contact.user_id + '@' + contact.user_source + ((contact.shop_id && contact.shop_source) ? ('@@' + contact.shop_id + '@' + contact.shop_source) : '');
    var tmpMsg = (!isEmpty(this._data.session.falseMsg) && this._data.session.falseMsg.msg_id) ? this._data.session.falseMsg : gdic.get('tmpMsg-session-' + contactkey);
    if (!isEmpty(tmpMsg) && this._data.session.msg && this._data.session.msg.msg_id && falseNewsDic.getExistFalseMsg(contactkey, this._data.session.msg.msg_id)) {
      if (!isEmpty(this._data.session.msg)) {
        if (strToNumCompare(tmpMsg.msg_id, this._data.session.msg.msg_id) > 0) {
          if (tmpMsg.call_type === 'audio') {
            content = '[语音通话]';
            if (tmpMsg.not_answered) {
              this._element.find(".im-last-msg").addClass('im-false-not-answered');
            }
          } else if (tmpMsg.call_type === 'video') {
            content = '[视频通话]';
            if (tmpMsg.not_answered) {
              this._element.find(".im-last-msg").addClass('im-false-not-answered');
            }
          } else {
            content = tmpMsg.content ? (tmpMsg.content.msg || '') : '';
          }
          time = timeFormatter(tmpMsg.send_time);
        } else {
          gdic.set('tmpMsg-session-' + contactkey, null);
        }
      }
    }
  }

  if (this._data.session.is_top_group) {
    this._element.find(".im-msg-time").hide();
    //this._element.find(".im-session-username").css('padding-right', '57px');
  } else {
    this._element.find(".im-msg-time").text(time);
  }
  // xssFilter,将'<'替换成’&lt;将'>'替换成&gt;
  content = XssFilter.doFilter(content);
  this._element.find(".im-last-msg").html(content);
  }
}

module.exports = ContactSessionItem;
